import { FormControl, FormLabel, TextField, Typography } from '@mui/material';
import { ControllerRenderProps, FieldError } from 'react-hook-form';

interface PhoneNumberFieldProps {
  label: string;
  disabled: boolean;
  value: string;
  onChange: ControllerRenderProps['onChange'];
  error?: FieldError;
  name: string;
  readOnly: boolean;
}

export const PhoneNumberField = ({ label, disabled, value, onChange, error, name, readOnly }: PhoneNumberFieldProps) => {
  return (
    <>
      <FormControl fullWidth size="small" data-cy-field-type="phone-number">
        <FormLabel id={`${name}-label`}>{label}</FormLabel>
        <TextField
          size="small"
          type="text"
          aria-labelledby={`${name}-label`}
          value={value}
          error={!!error}
          inputProps={{ readOnly }}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
        />
      </FormControl>
      {error ? <Typography color="error">{error!.message as string}</Typography> : <br />}
    </>
  );
};

export default PhoneNumberField;
